import styled from "styled-components";

import Colors from '../../themes/Colors';
export const SelectionCardHolder = styled.div`
  padding: 0px 10px;

  @media only screen and (max-width: 767px) {
    padding: 0;
  }

  /* Ambas tarjetas con la misma altura cuando van lado a lado */
  .ant-row-flex > .ant-col > * {
    height: 100%;
  }

  .ant-alert {
    margin-top: 5px;
  }

  .ant-alert-warning {
    background-color: ${Colors.tintWarning};
    border: 1px solid #ffe58f;
    color: ${Colors.coal};
    font-size: 14px;
  }
`;
